import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import $ from 'jquery';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class CloneStory extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            story_status: [],
            search: [],
            story: '',
            apiUrl: this.decryptconfigdata('apiUrl'),
            owners: [],
            owner: '',
            assign_to: [],
            story_attachment: [],
            priority: [],
            status: [],
            title: '',
            description: '',
            start_date: '',
            startdate: '',
            end_date: '',
            enddate: '',
            go_live_date: '',
            golivedate: '',
            files: '',
            attachments: '',
            attachment_url: '',
            created_date: '',
            workflow: [],
            config: [],
            related_to: [],
            last_updated_date: '',
            userId: has_local_data ? localdata.user_id : '',
            userName: has_local_data ? localdata.user_name : '',
            userAuthKey: has_local_data ? localdata.user_key : '',
            fields: {},
            errors: {},
            error_message: '',
            checkBox: true,
        }
        this.CloneStory = this.CloneStory.bind(this);
        this.onChange = this.onChange.bind(this);
        this.startdateChange = this.startdateChange.bind(this);
        this.enddateChange = this.enddateChange.bind(this);
        this.golivedateChange = this.golivedateChange.bind(this);
        this.getSearchERNumber = this.getSearchERNumber.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;

    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    
    rawjsonparse(findresponse, flg) {
        return findresponse;
    }

    handleUpdateInput = (searchText) => {
        console.log(searchText)
        this.setState({
            searchText: searchText,
        });
        this.getERNumber(searchText);
    };

    handleNewRequest = (searchText) => {
        this.getSearchERNumber();
    };

    enterKeyPress(event) {
        if (event.key == 'Enter') {
        }
    }

    getERNumber(searchText = '') {
        fetch(this.state.apiUrl + '/ErRest/getERNumber/userAuthKey/' + this.state.userAuthKey + '/searchText/' + searchText, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({
                        search: findresponse.ers,
                        errorText: ''
                    })
                } else {
                    this.setState({ errorText: findresponse.msg })
                }

            })
    }
    getSearchERNumber() {
        fetch(this.state.apiUrl + '/ErRest/getSearchERNumber/userAuthKey/' + this.state.userAuthKey + '/search/' + this.state.searchText, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({
                        ers: findresponse.ers,
                        item_count: findresponse.item_count,
                    })
                    if (this.state.item_count > 0) {
                        window.location.href = '/viewER/' + findresponse.er_id;
                    }
                }
                else {
                    alert("No result found");
                }
            })
    }

    focousOutStartDate(value) {
        if (!value) {
            this.setState({ startdate: '' });
            this.setState({ start_date: '' });
        }
    }

    startdateChange(event) {
        this.setState({ startdate: event, start_date: moment(event).format("YYYY-MM-DD") }, function () {

        });
    }
    enddateChange(event) {
        this.setState({ enddate: event, end_date: moment(event).format("YYYY-MM-DD") }, function () {

        });
    }

    focousOutEndDate(value) {
        if (!value) {
            this.setState({ enddate: '' });
            this.setState({ end_date: '' });
        }
    }

    golivedateChange(event) {
        this.setState({ golivedate: event, go_live_date: moment(event).format("YYYY-MM-DD") }, function () {

        });
    }

    focousOutGoLiveDate(value) {
        if (!value) {
            this.setState({ golivedate: '' });
            this.setState({ go_live_date: '' });
        }
    }

    handleValidation() {
        let fields = this.state.story;
        let errors = {};
        let formIsValid = true;
        if (!fields["title"]) {
            formIsValid = false;
            errors["title"] = "This field is required.";
        }
        if (!fields["priority"]) {
            formIsValid = false;
            errors["priority"] = "This field is required.";
        }
        if (!fields["assign_to"]) {
            formIsValid = false;
            errors["assign_to"] = "This field is required.";
        }
        if (!fields["user_id"]) {
            formIsValid = false;
            errors["user_id"] = "This field is required.";
        }
        if (!fields["story_text"].trim() && fields["story_link"].trim()) {
            formIsValid = false;
            errors["story_text"] = "This field is required.";
        }
        if (!fields["story_link"].trim() && fields["story_text"].trim()) {
            formIsValid = false;
            errors["story_link"] = "This field is required.";
        }
        //validate link start
        if (fields["story_link"].trim() && !this.isValidStoryLink(fields["story_link"].trim())) {
            formIsValid = false;
            errors["story_link"] = "Invalid Link.";
        }
        //validate link end

        this.setState({ errors: errors });
        return formIsValid;
    }

    isValidStoryLink(link) {
		var pattern = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
		return pattern.test(link);
	}

    onCheck(propertyName, event) {
        const story = this.state.story;
        var element = document.getElementById(propertyName);
        if (element.checked) {
            story[propertyName] = 1;
        } else {
            story[propertyName] = 0;
        }
        this.setState({ story: story });
    }

    CloneStory() {
        if (this.handleValidation()) {
            console.log("Data Has been submitted");
            //return true;
        } else {
            console.log("This Fields Are required.")
            return false;
        }
        //document.getElementById("add_request").innerHTML="Sending....";
        let img = document.getElementById('attachments').files.length;
        const fd = new FormData;
        if (img > 0) {
            for (var x = 0; x < img; x++) {
                fd.append("image[]", document.getElementById('attachments').files[x]);
            }
        }

        document.getElementById("add_request").disabled = true;
        fd.append('ticket_inputs', JSON.stringify(this.state));
        fetch(this.state.apiUrl + '/ErRest/CloneStory/id/' + this.props.match.params.storyId + '/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                document.getElementById("add_request").innerHTML = "Submit";
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {

                        if (findresponse.story_id)
                            window.location.href = '/viewStory/' + findresponse.story_id + '/sequence/' + findresponse.next_sequence;
                        else
                            window.location.href = '/er/';
                    });
                } else {

                    this.setState({ message: findresponse.msg })
                }

            })
    }

    getStoryDetails() {
        $(document).ready(function () {
            $('.loader-new').removeClass('hidden');
            $('.intranet_body').addClass('hidden');
        });
        fetch(this.state.apiUrl + '/ErRest/EditStory/id/' + this.props.match.params.storyId + '/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey)
            .then((Response) => Response.json())
            .then((responseJson) => {
                responseJson = this.rawjsonparse(responseJson, 1);
                $(document).ready(function () {
                    $('.loader-new').addClass('hidden');
                    $('.intranet_body').removeClass('hidden');
                });

                this.setState({
                    story: responseJson.story,
                    story_attachment: responseJson.story_attachment,
                    workflow: responseJson.workflow,
                    config: responseJson.config,
                    owners: responseJson.owner,
                    priority: responseJson.priority,
                    status: responseJson.status,
                    start_date: responseJson.story.start_date,
                    end_date: responseJson.story.end_date,
                    go_live_date: responseJson.story.go_live_date,
                    related_to: responseJson.related_to,
                    story_status: responseJson.story_status
                })

                document.title = responseJson.story.feature_id + '_' + this.props.match.params.seqNo;

                if (this.state.story.start_date && this.state.story.start_date != '0000-00-00') {
                    let x = Date.parse(this.state.story.start_date);
                    this.setState({ startdate: moment(x) })
                }
                if (this.state.story.end_date && this.state.story.end_date != '0000-00-00') {
                    let x = Date.parse(this.state.story.end_date);
                    this.setState({ enddate: moment(x) })
                }
                if (this.state.story.go_live_date && this.state.story.go_live_date != '0000-00-00') {
                    let x = Date.parse(this.state.story.go_live_date);
                    this.setState({ golivedate: moment(x) })
                }
                this.state.story.copy_attachments = 0;
                this.state.story.copy_notes = 0;
                this.state.story.related_to_er = '';
            })
    }

    onChange(propertyName, event) {
        const story = this.state.story;
        story[propertyName] = event.target.value;
        this.setState({ story: story });
    }
    showImage(s3url) {
        window.open(s3url);
    }
    delteimage(id, story_id, name) {
        if (window.confirm('Are you sure to delete ' + name + ' ?')) {
            fetch(this.state.apiUrl + '/ErRest/deleteStoryImage/id/' + id + '/er_id/' + story_id + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId)
                .then((Response) => Response.json())
                .then((findresponse) => {
                    this.getStoryDetails();
                })
        }
    }
    componentDidMount() {
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        this.getStoryDetails();

        $(document).ready(function () {
            $('.upload_btn label').click(function () {
                $('.upload_btn .inputfile').click();

            });
            $('.inputfile').each(function () {
                var $input = $(this),
                    $label = $input.next('label'),
                    labelVal = $label.html();

                $input.on('change', function (e) {
                    var fileName = '';

                    if (this.files && this.files.length > 1)
                        fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
                    else if (e.target.value)
                        fileName = e.target.value.split('\\').pop();

                    if (fileName)
                        $label.find('span').html(fileName);
                    else
                        $label.html(labelVal);
                });

                // Firefox bug fix
                $input
                    .on('focus', function () { $input.addClass('has-focus'); })
                    .on('blur', function () { $input.removeClass('has-focus'); });
            });


            if (window.File && window.FileList && window.FileReader) {
                $("#files").on("change", function (e) {
                    var files = e.target.files,
                        filesLength = files.length;

                });

            } else {
                alert("Your browser doesn't support to File API")
            }

        });
    }

    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }

        return (
            <div>
                <Header brecum_name="Er" brecum_page="Clone Story" />
                <div class="right_col">
                    <span className="error">{this.state.error_message}</span>
                    <div class="loader-new"></div>
                    <div class="intranet_body hidden">
                        <div class="title mob"><HeaderMob page_name="Clone Request" /></div>
                        <div class="form-group">
                        </div>
                        <div class="top-row-form">
                            <div class="form-group">
                                <label for="title">Story<span class="star">*</span></label>
                                <input type="text" name="title" id="title" className="form-control" value={this.state.story.title} onChange={this.onChange.bind(this, 'title')} />
                                <span class="error">{this.state.errors["title"]}</span>
                            </div>
                            <div class="form-group">
                                <label>Description<span class="star"></span></label>
                                <textarea class="form-control" name="description" id="description" value={this.state.story.description} onChange={this.onChange.bind(this, 'description')}></textarea>
                                <span class="error">{this.state.errors["description"]}</span>
                            </div>
                            <div class="form-group">
                                <label>Acceptance Criteria</label>
                                <textarea class="form-control" name="acceptance_criteria" id="acceptance_criteria" value={this.state.story.acceptance_criteria} onChange={this.onChange.bind(this, 'acceptance_criteria')}></textarea>
                            </div>
                            <div class="form-group">
                                <label>Story Link Text</label>
                                <input type="text" name="story_text" id="story_text" className="form-control" value={this.state.story.story_text} onChange={this.onChange.bind(this, 'story_text')} />
                                <span class="error">{this.state.errors["story_text"]}</span>
                        </div>
                            <div class="form-group">
                                <label>Story Link</label>
                                <input type="text" name="story_link" id="story_link" className="form-control" value={this.state.story.story_link} onChange={this.onChange.bind(this, 'story_link')} />
                                <span class="error">{this.state.errors["story_link"]}</span>
                            </div>
                        </div>
                        <div class="form-section add row">
                            <div class="form-group col-sm-3 col-xs-6">
                                <label>Reporter<span class="star">*</span></label>
                                <div class="filter">
                                    <select class="form-control" name="user_id" id="id" value={this.state.story.user_id} onChange={this.onChange.bind(this, 'user_id')} >
                                        <option value='' selected="selected">Any </option>
                                        {
                                            this.state.owners.map((dynamicData, key) =>
                                                <option value={dynamicData.id}>{dynamicData.name}</option>
                                            )
                                        }
                                    </select>
                                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                                </div>
                                <span class="error">{this.state.errors["user_id"]}</span>
                            </div>
                            <div class="form-group col-sm-3 col-xs-6">
                                <label>Priority<span class="star">*</span></label>
                                <div class="filter">
                                    <select class="form-control" name="priority" id="id" value={this.state.story.priority} onChange={this.onChange.bind(this, 'priority')} >
                                        <option value="" selected>Any</option>
                                        {
                                            this.state.priority.map((dynamicData, index) =>
                                                <option value={dynamicData.key}>{dynamicData.value}</option>
                                            )
                                        }
                                    </select>
                                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                                </div>
                                <span class="error">{this.state.errors["priority"]}</span>
                            </div>
                            <div class="form-group col-sm-3 col-xs-6">
                                <label>Assigned to<span class="star">*</span></label>
                                <div class="filter">
                                    <select id="assign_to" class="form-control" name="owner" value={this.state.story.assign_to} onChange={this.onChange.bind(this, 'assign_to')}>
                                        <option value='' selected="selected">Any </option>
                                        {
                                            this.state.owners.map((dynamicData, key) =>
                                                <option value={dynamicData.id}>{dynamicData.name}</option>
                                            )
                                        }
                                    </select>
                                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                                </div>
                                <span class="error">{this.state.errors["assign_to"]}</span>
                            </div>
                            {/* Er 66422-To avoid misconfiguration of new workflows,category is editable but status will be new */}
                            <div class="form-group col-sm-3 col-xs-6">
                                <label>Status</label>
                                <div class="filter">
                                    <select class="form-control" id="status" name="status" value={10} onChange={this.onChange.bind(this, 'status')}>
                                        <option value={10}>New</option>
                                    </select>
                                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                                </div>
                            </div>
                            <div class="form-group col-sm-3 col-xs-6 icon-live icon-date">
                                <label>Start Date</label>
                                <div class="filter right">
                                    <DatePicker
                                        selected={this.state.startdate}
                                        onChange={this.startdateChange}
                                        autoComplete='off'
                                        placeholderText="Start Date"
                                        dateFormat="DD/MM/YYYY"
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        maxDate={this.state.enddate ? this.state.enddate : (this.state.golivedate ? this.state.golivedate : '')}
                                        onBlur={event => this.focousOutStartDate(event.target.value)}
                                        isClearable={true}
                                    />
                                </div>
                            </div>
                            <div class="form-group col-sm-3 col-xs-6 icon-live icon-date">
                                <label>End Date</label>
                                <div class="filter right">
                                    <DatePicker
                                        selected={this.state.enddate}
                                        onChange={this.enddateChange}
                                        autoComplete='off'
                                        placeholderText="End Date"
                                        dateFormat="DD/MM/YYYY"
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        minDate={this.state.startdate}
                                        maxDate={this.state.golivedate}
                                        onBlur={event => this.focousOutEndDate(event.target.value)}
                                        isClearable={true}
                                    />
                                </div>

                            </div>
                            <div class="form-group col-sm-3 col-xs-6 icon-live icon-date">
                                <label>Go-live Date</label>
                                <div class="filter right">
                                    <DatePicker
                                        selected={this.state.golivedate}
                                        onChange={this.golivedateChange}
                                        autoComplete='off'
                                        placeholderText="Go Live Date"
                                        dateFormat="DD/MM/YYYY"
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        minDate={this.state.enddate ? this.state.enddate : (this.state.startdate ? this.state.startdate : '')}
                                        onBlur={event => this.focousOutGoLiveDate(event.target.value)}
                                        isClearable={true}
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-3 col-xs-6">
                                <p class="feature-check box">
                                    <input type="checkbox" name="copy_notes" id="copy_notes" onClick={this.onCheck.bind(this, 'copy_notes')} />
                                    <label for="copy_notes"><span></span>Copy Story notes</label>
                                </p>
                                </div>
                            <div class="col-sm-3 col-xs-6">
                                <p class="feature-check box">
                                    <input type="checkbox" name="copy_attachments" id="copy_attachments" onClick={this.onCheck.bind(this, 'copy_attachments')} />
                                    <label for="copy_attachments"><span></span>Copy attachments</label>
                                </p>
                                </div>
                            </div>
                        <div class="upload ">
                            <h4 class="pull-left border-bottom"></h4>
                            {
                                this.state.story_attachment.map((data, key) =>
                                    <div class="attached attach_delete">
                                        <span onClick={() => this.showImage(data.url)}  >
                                            <i class="far fa-file"></i>{data.attachment_name}
                                        </span>
                                        <span class="delete" onClick={() => this.delteimage(data.id, data.entity_id, data.attachment_name)}  >
                                            <i class="fa fa-trash"></i>
                                        </span>
                                    </div>
                                )}
                        </div>
                        <div class="upload">
                            <label>Add Attachment :</label>
                            <div class="upload_btn">
                                <input type="file" name="attachments" id="attachments" class="inputfile inputfile-1" data-multiple-caption="{count} files selected" multiple />
                                <label for="file-1">
                                    <i class="fa fa-plus hidden-sm" aria-hidden="true"></i>
                                    <span>Choose file</span>
                                    <i class="fa fa-cloud-upload-alt hidden-md" aria-hidden="true"></i>
                                </label>
                            </div>
                        </div>
                        <button type="submit" name="add_request" id="add_request" class="btn btn-sky mob-btn" onClick={() => this.CloneStory()}>Submit</button>
                        <Link to={`/viewStory/${this.state.story.id}/sequence/${this.props.match.params.seqNo}`} name={"max"}><button className="btn btn-blue hidden-sm">Back</button></Link>
                    </div>
                </div>
            </div>
        )
    }
}

export default CloneStory;


// WEBPACK FOOTER //
// ./src/components/er/cloneStory.js